/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_register_benefits_multiple_addresses = /** @type {(inputs: {}) => string} */ () => {
	return `Spravujte více adres`
};

const da_account_register_benefits_multiple_addresses = /** @type {(inputs: {}) => string} */ () => {
	return `Administrer flere adresser`
};

const de_account_register_benefits_multiple_addresses = /** @type {(inputs: {}) => string} */ () => {
	return `Mehrere Adressen verwalten`
};

const en_account_register_benefits_multiple_addresses = /** @type {(inputs: {}) => string} */ () => {
	return `Save multiple shipping addresses`
};

const es_account_register_benefits_multiple_addresses = /** @type {(inputs: {}) => string} */ () => {
	return `Gestiona varias direcciones`
};

const fr_account_register_benefits_multiple_addresses = /** @type {(inputs: {}) => string} */ () => {
	return `Gérez de multiples adresses`
};

const hu_account_register_benefits_multiple_addresses = /** @type {(inputs: {}) => string} */ () => {
	return `Több cím kezelése`
};

const it_account_register_benefits_multiple_addresses = /** @type {(inputs: {}) => string} */ () => {
	return `Gestisci più indirizzi`
};

const nl_account_register_benefits_multiple_addresses = /** @type {(inputs: {}) => string} */ () => {
	return `Meerdere adressen beheren`
};

const pl_account_register_benefits_multiple_addresses = /** @type {(inputs: {}) => string} */ () => {
	return `Zarządzaj wieloma adresami`
};

const pt_account_register_benefits_multiple_addresses = /** @type {(inputs: {}) => string} */ () => {
	return `Gerencie vários endereços`
};

const sv_account_register_benefits_multiple_addresses = /** @type {(inputs: {}) => string} */ () => {
	return `Hantera flera adresser`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_register_benefits_multiple_addresses = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_register_benefits_multiple_addresses(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_register_benefits_multiple_addresses", locale)
	if (locale === "cs") return cs_account_register_benefits_multiple_addresses(inputs)
	if (locale === "da") return da_account_register_benefits_multiple_addresses(inputs)
	if (locale === "de") return de_account_register_benefits_multiple_addresses(inputs)
	if (locale === "en") return en_account_register_benefits_multiple_addresses(inputs)
	if (locale === "es") return es_account_register_benefits_multiple_addresses(inputs)
	if (locale === "fr") return fr_account_register_benefits_multiple_addresses(inputs)
	if (locale === "hu") return hu_account_register_benefits_multiple_addresses(inputs)
	if (locale === "it") return it_account_register_benefits_multiple_addresses(inputs)
	if (locale === "nl") return nl_account_register_benefits_multiple_addresses(inputs)
	if (locale === "pl") return pl_account_register_benefits_multiple_addresses(inputs)
	if (locale === "pt") return pt_account_register_benefits_multiple_addresses(inputs)
	return sv_account_register_benefits_multiple_addresses(inputs)
};
export { account_register_benefits_multiple_addresses as "account.register_benefits.multiple_addresses" }